<div class="container">
  <ul class="nav nav-secondary account-details-nav gap-2">
    <a class="nav-item" [routerLink]="['/account']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
      <label class="font-size-14">{{ 'accounts.nav.profile' | translate }}</label>
    </a>
    <a class="nav-item" [routerLink]="['/activity']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
      <label class="font-size-14">{{ 'accounts.nav.activity' | translate }}</label>
    </a>
  </ul>
</div>
